<!--
 * @Author: lwk
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-03-01 11:44:14
 * @Description: 请填写简介
-->
<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-01-25 10:58:07
 * @Description: 日行一善s
-->
<template>
  <div class="publicStatic">
    <div class="manageRadio">
      <el-radio-group v-model="manageVal" size="mini" @input="tabChange">
        <el-radio-button label="manage">各部门发布统计</el-radio-button>
        <el-radio-button label="person">个人每天发布统计</el-radio-button>
      </el-radio-group>
    </div>
    <div>
      <el-row
        :gutter="24"
        type="flex"
        class="row-bg"
        justify="space-around"
        style="margin-bottom: 10px;"
      >
        <el-col :span="4">
          <div>
            <el-input
              v-if="manageVal === 'manage'"
              size="mini"
              placeholder="请输入部门名称"
              v-model="form.departmentName"
            ></el-input>
            <el-input
              v-else
              size="mini"
              placeholder="请输入个人名称"
              v-model="form.searchName"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="10">
          <el-row
            :gutter="24"
            type="flex"
            class="row-bg"
            justify="space-between"
          >
            <el-radio-group v-model="dateType" size="mini" @input="changeDate" style="display: flex;margin-right: 5px;">
              <el-radio-button label="yesterDay">昨日</el-radio-button>
              <el-radio-button label="week">本周</el-radio-button>
            </el-radio-group>
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :clearable="false"
            >
            </el-date-picker>
              <el-button
                @click="searchData"
                size="mini"
                type="primary"
                style="margin-left: 5px;"
                icon="el-icon-search"
                >查询</el-button
              >
          </el-row>
        </el-col>
        <el-col :span="1" :offset="4">
          <div style="display: flex;align-items: center;">
            <el-button @click="exportData" size="mini" type="primary"
              >导出</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row v-if="manageVal === 'manage'">
        <el-table :data="tableData" style="width: 100%;height: 100%;" :row-class-name="tableRowClassName" >
          <el-table-column
            prop="departmentName"
            align="center"
            label="部门"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="index" label="序号" align="center" width="120">
          </el-table-column>
          <el-table-column prop="name" label="姓名" align="center" width="120">
          </el-table-column>
          <el-table-column
            prop="position"
            label="职位"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column label="发布数量" align="center">
            <el-table-column
              prop="sendCount"
              label="日行一善"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="sendSum"
              label="总字数"
              align="center"
              width="120"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="发出数" align="center">
            <el-table-column
              prop="sendComment"
              label="评论"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="sendOn"
              label="点赞"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column prop="sendOff" label="点LOW" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column label="收到数" align="center">
            <el-table-column prop="receiveComment" label="评论" align="center">
            </el-table-column>
            <el-table-column prop="receiveOn" label="点赞" align="center">
            </el-table-column>
            <el-table-column prop="receiveOff" label="点LOW" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column prop="average" label="平均得分" align="center">
          </el-table-column>
        </el-table>
      </el-row>
      <el-row v-else>
        <el-table :data="tableDataPerson" style="width: 100%" height="500">
          <el-table-column prop="selectedDate" align="center" label="日期">
          </el-table-column>
          <el-table-column prop="employeeName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="numbers" label="数量" align="center">
          </el-table-column>
          <el-table-column prop="weekDays" label="星期" align="center">
          </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: center;margin-top: 10px;">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="checkPage"
          >
          </el-pagination>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getEmployeeData,
  getEmployeeDayData,
  exportEmployeeDayData,
  exportEmployeeData
} from "@/api/doOneGood";
import moment from "moment";

export default {
  name: "PublishStatistics",
  data() {
    return {
      form: {
        departmentName: "",
        searchName: "",
        startTime: "",
        endTime: ""
      },
      manageVal: "manage",
      dateTime: [
        moment()
          .subtract(1, "days")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "days")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ],
      dateType: "yesterDay",
      tableData: [],
      tableDataPerson: [],
      pageType: {
        page: 1
      },
      total: undefined
    };
  },
  mounted() {
    this.getEmployeeData();
  },
  methods: {
    searchData() {
      if (this.manageVal === "manage") {
        this.getEmployeeData();
        return;
      }
      this.getEmployeeDayData();
    },
    tabChange(val) {
      if (val === "manage") {
        this.getEmployeeData();
        return;
      }
      this.getEmployeeDayData();
    },
    changeDate(val) {
      switch (val) {
        case "yesterDay":
          this.form.startTime = moment()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.form.endTime = moment()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.dateTime = [this.form.startTime, this.form.endTime];
          break;
        case "week":
          moment().localeData()._week.dow = 1;
          this.form.startTime = moment()
            .week(moment().week())
            .startOf("week")
            .format("YYYY-MM-DD HH:mm:ss");
          this.form.endTime = moment()
            .week(moment().week())
            .endOf("week")
            .format("YYYY-MM-DD HH:mm:ss");
          this.dateTime = [this.form.startTime, this.form.endTime];
          break;

        default:
          break;
      }
    },
    async getEmployeeData() {
      this.form.startTime = this.dateTime[0];
      this.form.endTime = this.dateTime[1];
      const { code, data } = await getEmployeeData(this.form);
      if (code != 0) return;
      this.tableData = data;
    },
    async getEmployeeDayData() {
      this.form.startTime = moment(this.dateTime[0]).format("YYYY-MM-DD");
      this.form.endTime = moment(this.dateTime[1]).format("YYYY-MM-DD");
      const { code, data } = await getEmployeeDayData({
        ...this.form,
        ...this.pageType
      });
      if (code != 0) return;
      this.tableDataPerson = data.data;
      this.total = data.total;
    },
    checkPage(val) {
      this.pageType.page = val;
      this.getEmployeeDayData();
    },
    exportData() {
      if (this.manageVal === "manage") {
        exportEmployeeData(this.form).then(res => {
          const blob = new Blob([res.data]);
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "文件.xls";
          link.click();
        });
      } else {
        exportEmployeeDayData(this.form).then(res => {
          const blob = new Blob([res.data], {
            type: "application/json"
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "文件.xls";
          link.click();
        });
      }
    },
    tableRowClassName({row}) {
      return row.tableClass
    }
  }
};
</script>

<style lang="scss" scoped>
.publicStatic {
  .manageRadio {
    margin-bottom: 10px;
  }
}


</style>

<style>

.el-table .rowBackground {
    background: #F5F7FA;
  }
</style>


// WEBPACK FOOTER //
// src/components/OneGoodModule/PublishStatistics.vue